var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bb-application-contract-card',{staticClass:"demand-deposit-empty-state-card",attrs:{"data-testid":"demand-deposit-empty-state-card","icon":{ name: 'client-wave', fill: 'default' },"title":_vm.translations.title,"description":_vm.translations.description,"primary-button":{
    label: _vm.translations.buttonText,
    color: 'mint'
  }},on:{"primaryButtonClick":_vm.redirect}})}
var staticRenderFns = []

export { render, staticRenderFns }